import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { get, toLower } from 'lodash';
import {loginUser, updateUserDataAfterLogin} from '../../../store/calls';
import {
	addErrorAlert,
	toggleGlobalLoader,
	clearAllAlerts,
} from '../../../store/calls/alertLoadingDispatch';
import validators from "../../../utils/forms/validators";
import * as actions from '../../../store/actions';
import Logo from '../../theme/logo/logo';
// Local Components
import PublicWrapper from '../../theme/wrappers/PublicWrapper';
import BaseForm from '../../theme/forms/BaseForm';
import LoginForm from "../../subcomponents/auth/LoginForm";
import GoogleLoginButton from '../../subcomponents/auth/GoogleLoginButton';
import LinkedinLoginButton from '../../subcomponents/auth/LinkedinLoginButton';

class LoginScreen extends React.Component {
	constructor(props) {
		super(props);

		this.state = {isLoading: false}


	}

	componentDidMount() {
		toggleGlobalLoader(false);

		// check if props tokenData is already set
		if (this.props?.tokenData?.user_id) {
			this.afterLogin(this.props.tokenData);
		}
	}

	getPermissionsAndRedirectionPathFromToken = (userData) => {
		if (userData.admin) {
			return '/admin/funders/';
		}
		if (userData?.funder_admins?.length) {
			return '/admin/funders/';
		}
		if (userData?.program_admins?.length) {
			return '/admin/pace-programs/';
		} // note that here we don't explicitly need the "client" group to be written. If it isn't there, we just assume it as a catch all
		// have they entered an address
		if (get(this.props, 'formFlow.computed.address.formatted_address', null)) {
			return '/project';
		}
		
		return '/my-projects'
	};

	afterLogin = (userData) => {
		const {history, onLoginPath} = this.props;
		window.gtag('event', 'login', {
			method: 'login_page',
		});

		if (onLoginPath) {
			 this.props.setSessionVar({onLoginPath: false})
		}
		
		const urlParams = new URLSearchParams(window.location.search);
		const redirectParam = urlParams.get('redirect');
		
		let defaultPath = this.getPermissionsAndRedirectionPathFromToken(userData);
		history.push(redirectParam || onLoginPath || defaultPath);
	}

	render() {
		return (
			<PublicWrapper showNav={false} cornerCoverStyle={{ zIndex: 2 }}>
				<section className="hero is-fullheight" id="login-hero">
					<div className="hero-body" style={{ zIndex: 2 }}>
						<div
							className="container"
							style={{ maxWidth: '500px', width: '80vw' }}
						>
							<div className="box">
								<Logo />
								<LoginForm
									onSuccess={this.afterLogin}
								/>
								<div className="is-fullwidth is-flex is-flex-direction-column is-justify-content-center">
									<LinkedinLoginButton
										className='mt-5 is-medium is-fullwidth'
										successCallback={this.afterLogin}
										failureCallback={() => addErrorAlert("That didn't work. Please try again in a few seconds or use another method to login.")}
										redirectionURI={window.location.hostname === 'localhost' ? 'http://localhost:3000/login' : 'https://cleanfi.com/login'}
									/>
									<GoogleLoginButton
										className='is-button is-medium is-fullwidth mt-2'
										successCallback={this.afterLogin}
										failureCallback={() => addErrorAlert("That didn't work. Please try again in a few seconds or use another method to login.")}
									/>
								</div>
								<div className="is-fullwidth is-flex is-flex-direction-column mt-5">
									<Link to="/reset-password" className='is-flex is-justify-content-center'>
										<button className="button is-text has-text-primary mt-4">
											Forgot Password?
										</button>
									</Link>
									<Link to="/create-account"  className='is-flex is-justify-content-center'>
										<button className="button is-text has-text-primary">
											Create an Account
										</button>
									</Link>
									<Link to="/"  className='is-flex is-justify-content-center'>
										<button className="button is-text has-text-grey-light">
											Back
										</button>
									</Link>
								</div>
							</div>
						</div>
						</div>
				</section>
			</PublicWrapper>
		)
	}
}


const mapStateToProps = (state) => ({
	loading: state.user.loading,
	error: state.user.error,
	focusedProject: state.projectLeads.focusedProject,
	formFlow: state.formFlow,
	onLoginPath: state.session.vars?.onLoginPath,
	tokenData: state.user.decodedTokenData
});

const mapDispatchToProps = (dispatch) => ({
	updateTokenData: (data) => dispatch(actions.user.updateTokenData(data)),
	setSessionVar: (data) => dispatch(actions.session.setVar(data))
});


export default connect(mapStateToProps, mapDispatchToProps)(LoginScreen);
